import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'address',
})
export class AddressPipe implements PipeTransform {

    constructor () {}

    transform(item:any) {
        let lines = [];

        if (item.address || item.number || item.district){
            let line = [];
            if (item.address)
                line.push(item.address);
            if (item.number)
                line.push(item.number);
            if (item.district)
                line.push(item.district);
            lines.push(line.join(', '));
        }

        if (item.city || item.state || item.zipcode){
            let line = [];
            if (item.city)
                line.push(item.city);
            if (item.state)
                line.push(item.state);
            if (item.zipcode){
                if (item.length > 0){
                    line.push(line.pop() + ' CEP ' + item.zipcode);
                }else{
                    line.push('CEP ' + item.zipcode);
                }
            }
            lines.push(line.join(', '));
        }
        if (item.phone){
            lines.push('Fone / Fax: ' + item.phone);
        }

        return lines.map(line => '<p>' + line + '</p>').join('');
    }

}



// WEBPACK FOOTER //
// ./src/pipes/address/address.ts